'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TestPage$() {
}
export { $c_Lpresto_TestPage$ as $c_Lpresto_TestPage$ };
$p = $c_Lpresto_TestPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TestPage$;
/** @constructor */
function $h_Lpresto_TestPage$() {
}
export { $h_Lpresto_TestPage$ as $h_Lpresto_TestPage$ };
$h_Lpresto_TestPage$.prototype = $p;
$p.dm = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1082268063);
});
$p.l = (function() {
  return "TestPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "TestPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_TestPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TestPage$, "presto.TestPage$", ({
  Sd: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_TestPage$ as $d_Lpresto_TestPage$ };
var $n_Lpresto_TestPage$;
function $m_Lpresto_TestPage$() {
  if ((!$n_Lpresto_TestPage$)) {
    $n_Lpresto_TestPage$ = new $c_Lpresto_TestPage$();
  }
  return $n_Lpresto_TestPage$;
}
export { $m_Lpresto_TestPage$ as $m_Lpresto_TestPage$ };
//# sourceMappingURL=presto.-Test-Page$.js.map
